import React,{useState,useEffect, forwardRef,useRef} from 'react'
import "./EditableTable.css"
import { useDispatch } from 'react-redux';
import delete_icon from '../../../assets/reUsableTemplates_assets/delete_icon.png';
import download_icon from '../../../assets/reUsableTemplates_assets/dowload_icon.png';
import selected_icon from '../../../assets/reUsableTemplates_assets/selected_icon.png';
import action_icon from "../../../assets/reUsableTemplates_assets/action.png"
import slno_icon from "../../../assets/reUsableTemplates_assets/slno.png"
import table_delete_icon from "../../../assets/reUsableTemplates_assets/table_delete_icon.png"
import table_edit_icon from "../../../assets/reUsableTemplates_assets/table_edit_icon.png"
import arrow_up from "../../../assets/reUsableTemplates_assets/arrow_up.png"
import arrow_down from "../../../assets/reUsableTemplates_assets/arrow_down.png"
import { getUserRole } from "../../../services/global_redux/globale_actions/Role.action";
import { getCurrentMonth } from '../../../services/global_redux/globale_actions/Currentmonth.action';
import { downloadAllSelectedIDsRecords ,globalDownloadAllSelectedIDsRecords} from '../../../services/global_redux/globale_actions/Download.action';
import {getStates} from "../../../services/global_redux/globale_actions/States.action";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import Multiselect from 'multiselect-react-dropdown';

import { downloadAttenceRegister } from '../../../services/register_redux/register_actions/AttendanceRegister.action';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function EditableTable({mainIcon,MainIcon,mainIconColor, title ,header, data ,setEditableRow, setEditedValues, editedValues, handledeleteClickOpenalert, editableRow, setLoading ,useHolidays, getEditPermission ,getDeletePermission, date,handleSaveClick ,submitdelete,showSnackbar ,createOrfilterComp,editableTable,actionChecked,setActionChecked,stateList,viewOnly=false,monthfilterreport,hideColumnHeaderIcons=false}) {

  const [checkDelete, setCheckDelete] = useState(false);
  const [deletesingleID, setdeletesingleID] = useState({});
  const [checkEdit, setCheckEdit] = useState(false);
  const [selectedClient, setSelectedClient] = useState('');
  const [opendeletealert, setopendeletealert] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [openeditalert, setOpeneditalert] = useState(false);
  const dispatch = useDispatch();
  const [permissionsAction, setPermissionsAction] = useState(null);
  const [stateData,setStateData]=useState(null)
  const [opendeletemultialert, setopendeletemultialert] = useState(false);
  const [checkedItemCount, setCheckedItemCount] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentMonthIssame, setCurrentMonthIssame] = useState(false);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const containerRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [weeklyHolidaySelection, setWeeklyHolidaySelection] = useState({});



  const handleFetchStates = async () => {
    try {
      const response = await dispatch(getStates());
      setStateData(response.data.states);
    } catch (err) {
      console.error("Failed to fetch states:", err);
    }
  };

  useEffect(() => {
    handleFetchStates();
  }, [dispatch]);
  // sort funtion starts
  const handleSort = (key) => {
    setSortConfig((prev) => ({
        key,
        direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
};

const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "";
    return sortConfig.direction === "asc" ? arrow_up : arrow_down;
};
const filteredData = Array.isArray(data)
? data.filter(item =>
    Object.values(item).some(value =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  )
: [];
useEffect(() => {
  setCurrentPage(1);
 },[searchQuery]);
const sortedData = [...filteredData].sort((a, b) => {
  if (!sortConfig.key) return 0;
  const aVal = a[sortConfig.key];
  const bVal = b[sortConfig.key];
  if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
  if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
  return 0;
});

// pagination
const indexOfLastRecord = currentPage * recordsPerPage;
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
const currentRecords = sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
const totalPages = Math.ceil(sortedData.length / recordsPerPage);
const current_month = date;
const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
        setCurrentPage(pageNumber);
    }
};
 useEffect(()=>{
    if (typeof setActionChecked !== 'function') return;
    if(actionChecked === "create"){
      if(totalPages === 0){
        setCurrentPage(totalPages);
      }else{
        setCurrentPage(totalPages);
      setActionChecked("");
      }

    }else if(actionChecked === "delete"){
      if(currentPage != 1 && currentPage > totalPages){
        setCurrentPage(totalPages);
      setActionChecked("");
      }
    }else if (actionChecked){
      setActionChecked("");
    }
  },[actionChecked,totalPages,setActionChecked])
// useEffect(() => {
//   setCurrentPage(1);
// }, [data]);
const getPageSizeOptions = (totalEntries) => {
  const options = [ 10, 20, 50, 100,200,300,400,500,600,];
  const filtered = options.filter(size => size < totalEntries);

  return [...filtered, totalEntries];
};



const Frequency = (value) => {
  if (value === null || value === undefined) return "";
  switch (value.toLowerCase()) {
    case '1':
        return 'Weekly';
    case '2':
        return 'Monthly';
    case '3':
    return 'Anually';
    case '4':
        return '5 Yearly';
    case '5':
        return 'One Time';
    case '6':
      return 'All The Time';
    case '7':
        return 'As And When';
    case '8':
        return 'Quaterly';
    case '9':
      return 'Half Yearly';
    default:
        return 'Unknown';
  }
};
// const dueMonthOptions = (value) => {
//   if (value === null || value === undefined) return "";
  
//   // convert to Number safely
//   const num = Number(value);

//   if (value === "All") return "All";

//   // invalid or zero
//   if (!num || num < 1 || num > 12) return "";

//   const months = [
//     "", "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//     "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
//   ];

//   return months[num] || "";
// };

const dueMonthOptions = (value) => {
  if (value === null || value === undefined) return "";
  if (value === "All") return "All";

  const months = [
    "", "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  return value.toString().split(",").map(v => {
      const num = parseInt(v.trim(), 10); // ✅ safer
      if (isNaN(num) || num < 1 || num > 12) return "";
      return months[num];
    })
    .filter(m => m) // remove empty
    .join(", ");
};

const formatGender = (value) => {
  
  switch (value.toLowerCase()) {
      case 'm':
          return 'Male';
      case 'f':
          return 'Female';
      case 't':
          return 'Transgender';
      default:
          return 'Unknown';
  }
};
const formatBranchType = (value) => {
  
  switch (value) {
      case '1':
          return 'On Roll';
      case '2':
          return 'Contractor';
      case '3':
          return 'Both (On Roll & Contractor)';
  }
};
const formatStatus = (value) => {
  switch (Number(value)) {
      case 1:
          return 'Active';
      case 2:
          return 'In-active';
      default:
          return 'Unknown';
  }
};
// Editable table

const handleEditClick = (id) => {
  if(title === "Template"){
    editableTable(id);
  }else{
    const item = data.find(d => d.id === id);
    setEditableRow(id);
    setEditedValues({ ...item });
  }
};
const handleCancelClick = () => {
    setEditableRow(null);
    setEditedValues({});
};
// delete

const handledeletealert = (id) => {
  setopendeletealert(true)
  setdeletesingleID(id)
}
const handledeleteClickconfirmed = () => {
    setopendeletealert(false)
    handledeleteClickOpenalert(deletesingleID)
}
const handledeleteClosealert = () => {
    setopendeletealert(false)
}


const handleCheckChange = (id) => {
  setCheckedItems(prevCheckedItems => ({
      ...prevCheckedItems,
      [id]: !prevCheckedItems[id]
  }));
};

const handledeletemultiClosealert = () => {
  setopendeletemultialert(false)
  setCheckedItems({})
}
const selectedDelete = (e) => {
  e.preventDefault();
  const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
  setopendeletemultialert(false)
  const selectedid = { ids: selectedIds };
  submitdelete(selectedid);
};

useEffect(() => {
  setCheckedItems({})
}, [data]);

function formatDate(dateString) {
  
  if(dateString === null){
    return dateString
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
      return dateString;
  }

  const options = { day: '2-digit', month: 'short', year: 'numeric' };
  return new Intl.DateTimeFormat('en-GB', options).format(date).replace(/ /g, '-');
}
function formatDateForInput(dateString) {
  // Try to create a Date object from the provided date string
    
  if(dateString === null){
    return null
  }
  
  const date = new Date(dateString);

  // Check if the date is invalid
  if (isNaN(date.getTime())) {
      console.error("Invalid date string:", dateString);
      return null; // or handle the error as needed
  }

  return date.toISOString().split('T')[0];
}

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setEditedValues({
      ...editedValues,
      [name]: value,
  });
};
const handleCloseeditalert = () => {
    setOpeneditalert(false);
    setEditableRow(null);
    setEditedValues({});
};

const handleSaveClickconfirmed = () => {
  setOpeneditalert(false)
  handleSaveClick()
}
const handleSavealert = () => {
  setOpeneditalert(true)
}
const leaveCarryOptions = {
    0: " ",
    1: "Yes",
    2: "No",
};

const yearEndMonthOptions = {
    0: " ",
    1: "March",
    2: "December",
};

const genderBasedOptions = {
    0: " ",
    1: "Male",
    2: "Female",
    3: "All",
};

const joinedCreditOptions = {
    0: " ",
    1: "Full",
    2: "Half",
    3: "Zero",
};

const creditBaseOptions = {
    0: " ",
    1: "Monthly",
    2: "Annually",
};

const creditOnOptions = {
    0: " ",
    1: "Beginning of Base Value",
    2: "End of Base Value",
};

const getDisplayValue = (headerKey, value) => {
  switch (headerKey) {
      case 'leave_carry':
          return leaveCarryOptions[value] || value;
      case 'year_end_month':
          return yearEndMonthOptions[value] || value;
      case 'gender_based':
          return genderBasedOptions[value] || value;
      case 'joined_before_credit':
      case 'joined_after_credit':
          return joinedCreditOptions[value] || value;
      case 'credit_base':
          return creditBaseOptions[value] || value;
      case 'credit_on':
          return creditOnOptions[value] || value;
      case 'requires_balance_calculation':
          return value === 1 || value === '1' ? 'Yes (balance applies)' : 'No (display only)';
      case 'is_ml':
          return value === 1 || value === '1' ? 'Yes' : 'No';
      default:
          return value;
  }
};

const daysoptions = [
  { key: 'Sunday', value: '6' },
  { key: 'Monday', value: '0' },
  { key: 'Tuesday', value: '1' },
  { key: 'Wednesday', value: '2' },
  { key: 'Thursday', value: '3' },
  { key: 'Friday', value: '4' },
  { key: 'Saturday', value: '5' },
];
const handleWeeklyHolidayChange = (selectedList) => {
  const values =  selectedList.map(item => item.value).join(",");

  setWeeklyHolidaySelection(values);

  setEditedValues({
    ...editedValues,
    WeeklyHoliday: values,
  });
};



const renderCell = (item, headerItem) => {
  const isEditing = editableRow === item.id;
  const value = item[headerItem.key];
  let content;
  if(title === "Leave Configuration"){
    if(headerItem.input === "date"){
      content = isEditing ? (
        <input
          type="date"
          name={headerItem.key}
          value={formatDateForInput(editedValues[headerItem.key] || value)}
          onChange={handleInputChange}
          readOnly={headerItem.readOnly}
        />
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "state"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
        >
          <option value="">Select</option>
          {stateData?.map((item) => (
              <option key={item.state_name} value={item.state_name}>
                  {item.state_name}
              </option>
          ))}
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "leave_code"){
      content = isEditing ? (
        <input
          type="text"
          name={headerItem.key}
          value={editedValues[headerItem.key] ?? value ?? ""}
          onChange={handleInputChange}
          placeholder="e.g. SL, PL, EL"
        />
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "credit_on"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
        >
        <option value="">--select--</option>
        <option value="1">Begining of Base Value</option>
        <option value="2">End of Base Value</option>
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "credit_base"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
        >
        <option value="">--select--</option>
        <option value="1">Monthly</option>
        <option value="2">Annually</option>
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "joined_after_credit" || headerItem.input === "joined_before_credit"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
        >
        <option value="">--select--</option>
        <option value="1">Full</option>
        <option value="2">Half</option>
        <option value="3">Zero</option>
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "gender_based"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
        >
        <option value=" ">--select--</option>
        <option value="1">Male</option>
        <option value="2">Female</option>
        <option value="3">All</option>
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "year_end_month"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
        >
        <option value=" ">--select--</option>
        <option value="1">March</option>
        <option value="2">December</option>
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "leave_carry"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={(e) => {
            const val = e.target.value;
            setEditedValues({
              ...editedValues,
              leave_carry: val,
              leave_carry_val: (val === "1" || val === 1) ? (editedValues.leave_carry_val ?? item.leave_carry_val ?? "") : 0,
            });
          }}
        >
        <option value=" ">--select--</option>
        <option value="1">Yes</option>
        <option value="2">No</option>
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "requires_balance_calculation"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] ?? value ?? "1"}
          onChange={handleInputChange}
        >
        <option value="1">Yes (balance applies)</option>
        <option value="0">No (display only)</option>
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.input === "is_ml"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] ?? value ?? "0"}
          onChange={handleInputChange}
        >
        <option value="0">No</option>
        <option value="1">Yes</option>
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }else if(headerItem.key === "leave_carry_val"){
      const leaveCarry = editedValues?.leave_carry ?? item?.leave_carry;
      const isLeaveCarryNo = leaveCarry === "2" || leaveCarry === 2;
      if (isLeaveCarryNo) {
        content = isEditing ? "-" : (value ?? "-");
      } else {
        content = isEditing ? (
          <input
            type="number"
            name={headerItem.key}
            value={editedValues[headerItem.key] ?? value ?? ""}
            onChange={handleInputChange}
          />
        ) : (value ?? "");
      }

    }else{
      content = isEditing ? (
        <input
          type="text"
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
          readOnly={headerItem.readOnly}
        />
      ) : value ?? "";

    }

  }else{
    if (headerItem.input === "date") {
      content = isEditing ? (
        <input
          type="date"
          name={headerItem.key}
          value={formatDateForInput(editedValues[headerItem.key] || value)}
          onChange={handleInputChange}
          readOnly={headerItem.readOnly}
        />
      ) : formatDate(value); // <-- just return value (string), not <span>
    } else if(headerItem.input === "state"){
      content = isEditing ? (
        <select
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
        >
          <option value="">Select</option>
          {stateData?.map((item) => (
              <option key={item.state_name} value={item.state_name}>
                  {item.state_name}
              </option>
          ))}
        </select>
      ) : getDisplayValue(headerItem.key ,value);

    }
    else if (headerItem.input === "file") {
      content = isEditing ? (
        <input
          type="file"
          name={headerItem.key}
          value=""
          onChange={handleInputChange}
          readOnly={headerItem.readOnly}
        />
      ) : formatDate(value); // <-- just return value (string), not <span>
    }else if (headerItem.key === "WeeklyHoliday") {    
      if (isEditing) {
        const initialSelected = value
      ? value.split(',').map(val => daysoptions.find(opt => opt.value === val.trim()))
      : [];
    
        content = (
          <Multiselect
            options={daysoptions}
            displayValue="key"
            selectedValues={initialSelected}
            onSelect={handleWeeklyHolidayChange}
            onRemove={handleWeeklyHolidayChange}
            placeholder="Select days"
          />
        );
      } else {
    const dayNames = value
      ? value
          .split(",")
          .map(val => val.trim())
          .map(val => daysoptions.find(opt => opt.value.toString() === val)?.key)
          .filter(Boolean) 
          .join(", ")
      : "";

    content = dayNames;
  }

    }
    
    else if (headerItem.input === "holiday") {
      if (isEditing) {
        content = (
          <select
            name={headerItem.key}
            value={editedValues[headerItem.key] || ""}
            onChange={handleInputChange}
          >
            <option value="">--select--</option>
            {useHolidays?.map((holiday) => (
              <option key={holiday.id} value={holiday.id}>
                {holiday.hol_name}
              </option>
            ))}
          </select>
        );
      } else {
        const holiday = useHolidays?.find((h) => h.id === value);
        // content = holiday?.hol_name || "N/A"; // <-- just raw text
        content = value || ""; // <-- just raw text
      }
    } 
    else if (headerItem.key === "branch_type") {
      if (isEditing) {
        content = (
          <select
            name={headerItem.key}
            value={editedValues[headerItem.key] || ""}
            onChange={handleInputChange}
          >
            <option value="" disabled>--select--</option>
            <option value="1">On Roll</option>
            <option value="2">Contractor</option>
            <option value="3">Both S&E and Contractor</option>
          </select>
        );
      } else {
        content = formatBranchType(value); // <-- raw value
      }
    } 
    else if (headerItem.key === "gender") {
      if (isEditing) {
        content = (
          <select
            name={headerItem.key}
            value={editedValues[headerItem.key] || ""}
            onChange={handleInputChange}
          >
            <option value="" disabled>--select--</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
            <option value="T">Transgender</option>
          </select>
        );
      } else {
        content = formatGender(value); // <-- raw value
      }
    } 
    else if (headerItem.key === "frequency") {
      if (isEditing) {
        content = (
          <select
            name={headerItem.key}
            value={editedValues[headerItem.key] || ""}
            onChange={handleInputChange}
          >
            <option value="" disabled>--select--</option>
            <option value="1">Weekly</option>
            <option value="2">Monthly</option>
            <option value="3">Anually</option>
            <option value="4">5 Yearly</option>
            <option value="5">One Time</option>
            <option value="6">All The Time</option>
            <option value="7">As And When</option>
            <option value="8">Quaterly</option>
          </select>
        );
      } else {
        content = Frequency(value); // <-- raw value
      }
    } 
    else if (headerItem.key === "dueMonth") {
      if (isEditing) {
        content = (
          <select
            name={headerItem.key}
            value={editedValues[headerItem.key] || ""}
            onChange={handleInputChange}
          >
            <option value="" disabled>--select--</option>
          <option value="1">Jan</option>
          <option value="2">Feb</option>
          <option value="3">Mar</option>
          <option value="4">Apr</option>
          <option value="5">May</option>
          <option value="6">Jun</option>
          <option value="7">Jul</option>
          <option value="8">Aug</option>
          <option value="9">Sep</option>
          <option value="10">Oct</option>
          <option value="11">Nov</option>
          <option value="12">Dec</option>
          <option value="All">All Months</option>
          </select>
        );
      } else {
        content = dueMonthOptions(value);
        // content = "dddd";
      }
    } 
    else if (headerItem.key === "role_status") {
      if (isEditing) {
        content = (
          <select
            name={headerItem.key}
            value={editedValues[headerItem.key] || ""}
            onChange={handleInputChange}
          >
            <option value="" disabled>--select--</option>
            <option value="1">Active</option>
            <option value="2">In-active</option>
          </select>
        );
      } else {
        content = value == 1 ? "Active" : value == 2 ? "In-active" : "Unknown";
      }
    } 
    else {
      content = isEditing ? (
        <input
          type={headerItem.input}
          name={headerItem.key}
          value={editedValues[headerItem.key] || ""}
          onChange={handleInputChange}
          readOnly={headerItem.readOnly}
        />
      )  : Array.isArray(value)
      ? value.join(", ")
      : value ?? "";
    }

  }
  if (isEditing) {
    return content;
  } else {
    if (headerItem.dataIcon) {
      const letter = content?.charAt(0)?.toUpperCase() || "N";
      return (
        <div className="d-flex align-items-center gap-2 reuseableEditable-avatar-circle-main">
          <div className={`reuseableEditable-avatar-circle ${title === "Holiday" ? "holiday-avater-color" : ""}`}>
            {letter}
          </div>
          {headerItem.highlightName ? (
            <span className="highlight-text">{content}</span>
          ) : (
            <span>{content}</span>
          )}
        </div>
      );
    } 
    else if (headerItem.highlightName) {
      if (title === "Holiday") {
        if (content === "National Holiday") {
          return <span className="reuseableEditable-highlight-text National-holiday-highlight-color">{content}</span>;
        } else if (content === "Festival Holiday") {
          return <span className="reuseableEditable-highlight-text Festival-holiday-highlight-color">{content}</span>;
        } else {
          return <span className="reuseableEditable-highlight-text">{content}</span>;
        }
      } else if (title === "Role") {
        if (content === "Active") {
          return <span className="reuseableEditable-highlight-text role-Active-highlight-color">{content}</span>;
        } else if (content === "In-active") {
          return <span className="reuseableEditable-highlight-text role-In-active-highlight-color">{content}</span>;
        } else {
          return <span className="reuseableEditable-highlight-text">{content}</span>;
        }
      } else {
        return <span className="reuseableEditable-highlight-text">{content}</span>;
      }
    } 
    else {
      return <span>{content}</span>;
    }
  }
};

const getUserPermission = async () => {
  try {
      const response = await dispatch(getUserRole());    
      const rawPermissions = response?.data?.permissions;
      const parsedPermissions = typeof rawPermissions === "string"
          ? JSON.parse(rawPermissions)
          : Array.isArray(rawPermissions) && typeof rawPermissions[0] === "string"
          ? JSON.parse(rawPermissions[0])
          : rawPermissions;

      parsedPermissions.forEach((item) => {
          const { section, module, sub_module } = item;

          if (section === "InputMatrix" && module === "InputMatrix") {
              setPermissionsAction(sub_module);
          }
      });

  } catch (err) {
      console.error("Failed to fetch permissions:", err);
  }
};
const checkSubModules = () => {
  if (viewOnly) {
      setCheckEdit(false);
      setCheckDelete(false);
      return;
  }
  if ( getDeletePermission !== undefined && getEditPermission !== undefined) {
      
      setCheckEdit(getEditPermission);
      setCheckDelete(getDeletePermission);
  } else {
      if (permissionsAction != null) {
          permissionsAction.forEach(({ action, name }) => {
              if (name == title) {
                  setCheckEdit(action.edit);
                  setCheckDelete(action.delete);
              }
          })
      }
  }
};
useEffect(() => {
    getUserPermission();
}, [dispatch]);
useEffect(() => {
  checkSubModules();
}, [permissionsAction, getEditPermission, getDeletePermission, setPermissionsAction, viewOnly]);

const fetchcurrmonth = async () => {
  try {
      const response = await dispatch(getCurrentMonth());
      const rawDate = response.data[0].current_month;
      const currdate = new Date(rawDate);

      if (!isNaN(currdate)) {
          const year = currdate.getFullYear();
          const month = String(currdate.getMonth() + 1).padStart(2, '0');
          const day = String(currdate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          if(formattedDate === date){
                  setCurrentMonthIssame(true)
          }

      } else {
          console.error('Invalid date:', rawDate);
      }

  } catch (err) {
      console.error("Failed to fetch clients:", err);
  }
};

useEffect(() => {
  fetchcurrmonth();
}, [dispatch]);


const submitdownload = async (data) => {
    setLoading(true);
    if(title === "Attendance Register"){
    try {
      setLoading(true);
      const response = await dispatch(downloadAttenceRegister(data));
      if (response.success === true) {
        showSnackbar("Downloaded", 'success');
            setLoading(false);
            setCheckedItems({})
      } else {
        showSnackbar(response.message, 'warning');
            setLoading(false);
      }
    } catch (err) {
      showSnackbar('An error occurred', 'error');
            setLoading(false);
    } finally {
      setLoading(false);
            setLoading(false);
    }
    }else{
    try {
      let response
      if(title === "Act" || title === "Rule" || title === "Activity" || title === "Template"){
        response = await dispatch(globalDownloadAllSelectedIDsRecords(data));
      }else{
        response = await dispatch(downloadAllSelectedIDsRecords(data));
      }
        if (response.success == true) {
            showSnackbar(`Downloaded ${title} Successfully`, 'success');
            setLoading(false);
            setCheckedItems({})
        } else {
            showSnackbar(response.error, 'warning');
            setLoading(false);
        }
    } catch (error) {
        showSnackbar('An error occurred', 'error');
        setLoading(false);
    }
    }
}

// const handleCheckAll = (e) => {
//   const checked = e.target.checked;
//   setIsAllChecked(checked);

//   const newCheckedItems = { ...checkedItems };
//   currentRecords.forEach((item) => {
//     newCheckedItems[item.id] = checked;
//   });

//   setCheckedItems(newCheckedItems);
// };
const handleCheckAll = (e) => {
  const checked = e.target.checked;

  setCheckedItems(prev => {
    const updated = { ...prev };

    currentRecords.forEach((item) => {
      updated[item.id] = checked;
    });

    return updated;
  });

  setIsAllChecked(checked);
};

// const updateCheckAllState = () => {
//     const allChecked = data?.length > 0 && data.every(item => checkedItems[item.id]);
//     setIsAllChecked(allChecked);
// };
const updateCheckAllState = () => {
    const allChecked =
        currentRecords?.length > 0 &&
        currentRecords.every(item => checkedItems[item.id]);

    setIsAllChecked(allChecked);
};
useEffect(() => {
    updateCheckAllState();
    const count = Object.values(checkedItems).filter(Boolean).length;
    setCheckedItemCount(count);
}, [checkedItems, currentRecords]);

const handleDeleteSelected = () =>{
  if (checkedItemCount == 0) {
    showSnackbar("select the row", 'warning');
} else{
  setopendeletemultialert(true)
}
}
const handleDownloadSelected = () =>{
  if (checkedItemCount == 0) {
    showSnackbar("select the row", 'warning');
} else{
  
  const itemDatas = data;
  if(title == 'Branch Holidays') {
    const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
    let storedId = [];
    let storedHoliId = [];
    selectedIds.forEach(datas => {
        const item = itemDatas.find(d => d.id === datas);
        storedId.push(item.row_id);
        storedHoliId.push(item.old_id);
    });

    const client_id = sessionStorage.getItem('selectedClient')
    const data = {
        client_id: client_id,
        current_month: current_month,
        titleName: title,
        selectedIds: storedHoliId,
        ids: storedId
    }
    submitdownload(data);
  } else {
      const selectedIds = Object.keys(checkedItems).filter(id => checkedItems[Number(id)]).map(id => Number(id));
      const client_id = sessionStorage.getItem('selectedClient')
      const data = {
          client_id: client_id,
          current_month: current_month,
          titleName: title,
          selectedIds: selectedIds
      }
      submitdownload(data);
  }
}
  
}
  useEffect(() => {
    const checkScrollable = () => {
      if (containerRef.current) {
        const { scrollWidth, clientWidth } = containerRef.current;
        setIsScrollable(scrollWidth > clientWidth);
      }
    };

    checkScrollable(); // run once on mount
    window.addEventListener("resize", checkScrollable); // run on resize
    return () => window.removeEventListener("resize", checkScrollable);
  }, [data]);
  return (
    <div className='container-fluid FormsTable-main-contaner '>
      <div className='row FormsTable-main'>
          <div className="table-header">
            <div className="row d-flex">
                {/* <form onSubmit={handledeletemultialert} className='p-0 m-0'> */}
                  <div className="col d-flex justify-content-between  pe-1">
                    <div className="title-data d-flex align-items-center flex-wrap"><div className="table_main_img" style={{ backgroundColor: mainIconColor }} >{MainIcon ? <MainIcon className="dataImg tableTitleSvgIcon" aria-hidden="true" /> : <img src={mainIcon} alt="noImg" className='dataImg' />}</div>
                      <p className="dataTitle">{title} List</p> 
                      <div className="FormsTable-search-box position-relative">
                        <input
                          type="text"
                          className=""
                          placeholder="Search here..."
                          style={{
                            backgroundColor: "#f9fafb",
                            border: "none",
                            width: "250px"
                          }}
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <i
                        className="bi bi-search position-absolute"
                        style={{
                          top: "39%",
                          left: "20px",
                          transform: "translateY(-50%)",
                          color: "#9ca3af"
                        }}
                        ></i>
                      </div>
                      {monthfilterreport ? (
                        <div className="editable-table-search-addon">
                          {monthfilterreport}
                        </div>
                      ) : null}
                    </div>
                    <div className='float-end d-flex'>             
                      <button className='formsTable_icon_btn' onClick={handleDownloadSelected}><img src={download_icon} alt="noImg" className='download_icon p-0 m-0' /></button> 
                      {/* {checkDelete === true && title !== "Role" && <button className='formsTable_icon_btn'  onClick={handleDeleteSelected}><img src={delete_icon} alt="noImg" className='delete_icon p-0 m-0' /></button>} */}
                      {currentMonthIssame && (<button className='formsTable_icon_btn'  onClick={handleDeleteSelected}><img src={delete_icon} alt="noImg" className='delete_icon p-0 m-0' /></button>)}
                      {/* <div className='formsTable_icon_btn'><img src={selected_icon} alt="" /></div>      */}
                        <div className="formsTable_icon_btn" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
                          <img src={selected_icon} alt="" />
                          {showTooltip && (
                              <div className="tooltipww">
                                  Selected: {checkedItemCount}
                              </div>
                          )}
                      </div>
                      <div className="dataTotalEntries"><p>Total Entries :{data?.length}</p></div>
                      {createOrfilterComp && <div className="filter_or_createcomponentn">
                        {createOrfilterComp}
                      </div>}  
                    </div>
                  </div>
                  <div className="table-body bg-light p-0">
                    <div
                     ref={containerRef}
                     className={`table-responsive reuseableEditable ${
                       isScrollable ? "is-scrollable-table" : ""
                     }${currentRecords.length === 0 ? " is-empty-table" : ""}`}
                    
                    >
                      <table className='table p-0 m-0' id='dataTable'>
                        <thead>
                          <tr>
                            <th><input type="checkbox" className='' name="" id=""  checked={isAllChecked} onChange={handleCheckAll}/></th>
                            <th className='slno'>
                              <img src={slno_icon} alt="noImg" className='headerIcon' />
                            SL No.</th>
                            {header?.map((headerItem) => (
                              <th
                                  key={headerItem.key}
                                  onClick={() => handleSort(headerItem.key)}
                                  style={{ cursor: "pointer" }}
                                  className=""
                              >
                                {!hideColumnHeaderIcons && headerItem.Icon ? (
                                  <headerItem.Icon className="headerIcon headerSvgIcon" aria-hidden="true" />
                                ) : !hideColumnHeaderIcons && headerItem.icon ? (
                                  <img src={headerItem.icon} alt="noImg" className='headerIcon' />
                                ) : null}
                                {headerItem.value === "Client ID"
                                  ? "Organization ID"
                                  : headerItem.value === "Unit ID"
                                    ? "Branch ID"
                                    : headerItem.value} {getSortIcon(headerItem.key) &&<img src={getSortIcon(headerItem.key)} alt="" className='arrow_img'/>}
                              </th>
                            ))}
                            {title === "Org. Details" && (
                              <th className=' unitdataheader'>Add Units</th>
                          )}
                            {checkEdit === true || checkDelete === true ? (
                              <th className='action_dataIconheader'><img src={action_icon} alt="noImg" className='headerIcon' />Action</th>
                            ) : (<></>)}
                          </tr>
                        </thead>
                            <tbody>
                              {currentRecords.length > 0 ? (
                                currentRecords.map((item, index) => (
                                  <tr key={item.id} data-id={item.id}>
                                    <td className="tabletdheight">
                                      <div className="table-td-div">
                                        <span>
                                        <input
                                          type="checkbox"
                                          key={item.id}
                                          className=''
                                          checked={checkedItems[item.id] || false}
                                          onChange={() => handleCheckChange(item.id)}
                                        />
                                        </span>
                                      </div>
                                    </td>

                                    <td className="tabletdheight slno" >
                                      <div className="table-td-div mt-1">
                                        {indexOfFirstRecord + index + 1}
                                      </div>
                                    </td>

                                    {header.map((headerItem) => (
                                      
                                      <td key={headerItem.key} className="tabletdheight">
                                        <div className="table-td-div">
                                          
                                          {renderCell(item, headerItem)}
                                        </div>
                                      </td>
                                    ))}

                                    {title === "Org. Details" && (
                                        <td className='text-center unitdata'>
                                            <a href={`unit-master/${item.client_id}`}>
                                                <i className="bi bi-file-plus cursor-pointer text-success auction-btn"></i>
                                            </a>
                                        </td>
                                    )}
                                    {(checkEdit || checkDelete) && (
                                      <td className="text-center action_dataIcon">
                                        {editableRow === item.id ? (
                                          <div className="d-flex justify-content-between">
                                            <span
                                              onClick={handleSavealert}
                                              className=" p-0"
                                            >
                                              <i className="bi bi-floppy2-fill text-success auction-btn" style={{ cursor:"pointer" }} ></i>
                                            </span>
                                            <span
                                              onClick={handleCancelClick}
                                              className=" p-0"
                                            >
                                              <i className="bi bi-x-circle text-info auction-btn" style={{ cursor:"pointer" }}></i>
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="d-flex ">
                                            {checkEdit && (
                                              <span
                                                onClick={() => handleEditClick(item.id)}
                                                className=" p-0"
                                              >
                                                <div className="action_icon action_edit_icon"><img src={table_edit_icon} alt="" className='edit_icon'/></div>
                                              </span>
                                            )}
                                            {checkDelete && (
                                              <span
                                                onClick={() => handledeletealert(item.id)}
                                                className=" p-0"
                                              >
                                                <div className="action_icon action_delete_icon"><img src={table_delete_icon} alt="" className='delete_icon'/></div>
                                              </span>
                                            )}
                                          </div>
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                ))
                              ) : (
                                <tr className="editable-empty-row">
                                  <td
                                    colSpan={Math.max((header?.length || 0) + 2, 3)}
                                    className="editable-empty-msg"
                                  >
                                    <div className="editable-empty-msg-inner">
                                      No record available
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>

                      </table>
                    </div>
                    </div>
                  {/* </form> */}
              <div className="col-md-12">
              <div className="pagination align-items-center justify-content-between mt-3 row">
                <div className="col-md-12 text-center">
                <div>
                  {/* Prev button */}
                  <button
                    className="page-btn-arrow"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &lt;
                  </button>

                  {(() => {
                    const pages = [];

                    if (totalPages <= 10) {
                      // Show all pages if small count
                      for (let i = 1; i <= totalPages; i++) {
                        pages.push(i);
                      }
                    } else {
                      pages.push(1); // Always show first

                      // Left ellipsis
                      if (currentPage > 4) {
                        pages.push("...");
                      }

                      // Sliding window around current page
                      const start = Math.max(2, currentPage - 2);
                      const end = Math.min(totalPages - 1, currentPage + 2);

                      for (let i = start; i <= end; i++) {
                        pages.push(i);
                      }

                      // Right ellipsis
                      if (currentPage < totalPages - 3) {
                        pages.push("...");
                      }

                      pages.push(totalPages); // Always show last
                    }

                    return pages.map((p, idx) =>
                      p === "..." ? (
                        <span key={`ellipsis-${idx}`} className="ellipsis">
                          ...
                        </span>
                      ) : (
                        <button
                          key={p}
                          className={`page-btn ${currentPage === p ? "active" : ""}`}
                          onClick={() => handlePageChange(p)}
                        >
                          {p}
                        </button>
                      )
                    );
                  })()}

                  {/* Next button */}
                  <button
                    className="page-btn-arrow"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &gt;
                  </button>
                </div>

                </div>

                <div className="col-md-12">
                <div className="row float-end">
                <div className="d-flex align-items-center showPerPage">
                  <span className="me-2">Show per page:</span>
                  <select
                    value={recordsPerPage}
                    onChange={(e) => {
                      setRecordsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    {getPageSizeOptions(sortedData.length).map((size, i) => (
                      <option key={i} value={size}>
                        {size === sortedData.length ? "All" : size}
                      </option>
                    ))}
                  </select>
                </div>
                </div>
                </div>
              </div>
              </div>

            </div>
          </div>
      </div>
      
      <Dialog
          open={openeditalert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to edit this {title}? Any unsaved changes might be lost.
              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handleCloseeditalert}>No</Button>
              <Button onClick={handleSaveClickconfirmed}>Yes</Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={opendeletealert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to delete this {title}? This action cannot be undone.

              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handledeleteClosealert}>No</Button>
              <Button onClick={handledeleteClickconfirmed}>Yes</Button>
          </DialogActions>
      </Dialog>
      <Dialog
          open={opendeletemultialert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to delete those {title}? This action cannot be undone.

              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handledeletemultiClosealert}>No</Button>
              <Button onClick={selectedDelete}>Yes</Button>
          </DialogActions>
      </Dialog>
    </div>
  )
}

export default EditableTable